var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "#75C2F6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1688 13.8115C12.0761 15.0523 8.17519 23.0845 9.37565 27.0442C9.91632 28.8276 11.6211 29.4741 13.9367 28.7721C16.4538 28.009 17.7274 26.2235 19.7462 25.6115C21.7825 24.9942 23.8378 25.7704 26.3327 25.014C28.6484 24.312 29.7071 22.8277 29.1664 21.0443C27.966 17.0846 20.2615 12.5707 16.1688 13.8115ZM8.38286 15.4683C7.31006 13.8602 5.31113 13.2142 3.91815 14.0248C2.52517 14.8355 2.26587 16.7961 3.33867 18.4042C4.41146 20.0123 6.41039 20.6584 7.80337 19.8477C9.19635 19.0371 9.45565 17.0765 8.38286 15.4683ZM12.4273 13.0827C13.8958 12.1834 14.046 9.80551 12.7632 7.77175C11.4803 5.73798 9.25002 4.8189 7.78153 5.71829C6.31303 6.61767 6.16277 8.99552 7.44564 11.0293C8.72852 13.0631 10.9595 13.9825 12.4273 13.0827ZM26.4752 7.18681C24.8666 7.28615 23.5634 8.93329 23.5637 10.8666C23.5645 12.7997 24.8689 14.2862 26.4775 14.1869C28.0861 14.0876 29.3893 12.4404 29.389 10.5072C29.3882 8.57404 28.0838 7.08747 26.4752 7.18681ZM18.8758 11.1278C20.5965 11.0603 21.9409 9.05748 21.8785 6.65372C21.8161 4.24996 20.3708 2.35636 18.65 2.42333C16.9291 2.4903 15.5848 4.49362 15.6473 6.89738C15.7097 9.30114 17.1551 11.1952 18.8758 11.1278Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaw);
export default __webpack_public_path__ + "static/media/paw.6a785db1d7a888488d2c6f8b105a8e26.svg";
export { ForwardRef as ReactComponent };